import React from 'react';
import px from 'prop-types';
import cx from 'classnames';
import AutoWidth from './AutoWidth';
 
export default function AutoWidthText({style, className, text}) {
 
  return (
    <div className={cx(className)} style={style}>
        <AutoWidth
            as={'div'}
        >{text}</AutoWidth>
    </div>
  );
}
 
AutoWidthText.propTypes = {
  className: px.string,
    style: px.object,
    text: px.string,
};
 